'use strict';

var bind = require('./util/bind');
var defaultUrl = 'https://tp.qunar.com/touch/touchCashier?';

module.exports = function (config) {
    var sdk = this;
    var cashierHandle = function cashierHandle(options) {
        var cashierUrl = options.url ? options.url + '?' : defaultUrl;
        Object.keys(options).forEach(function (v) {
            if (['success', 'fail', 'url'].indexOf(v) === -1) {
                cashierUrl += v + '=' + options[v] + '&';
            }
        });
        location.href = cashierUrl.replace(/&$/g, '');
    };

    var api = {
        /**
         * 调用收银台<br />
         * @method hysdk.openCashier
         * @category Qunar
         * @example ./openCashier.js[1-20]
         * @description
         *
         * hy 参数说明
         *
         * | 参数 | 类型 | 描述 | 必选 | 注明 |
         * | :--: | :--: | :--: | :--: | :--: |
         * | hbToken | String | 订单token值 | √ | 常用参数 |
         * | fKey | String | 订单key值 | √ | 常用参数 |
         * | hbExt | String | 业务扩充功能字段 | X | 常用参数 |
         * | success | Function | success 回调 | X | 常用参数 |
         * | fail | Function | fail 回调 | X | 常用参数 |
         *
         * touch 参数说明
         *
         * | 参数 | 类型 | 描述 | 必选 | 注明 |
         * | :--: | :--: | :--: | :--: | :--: |
         * | url | String | touch 收银台地址 | X | 常用参数，默认 "https:&#47;&#47;tp.qunar.com/touch/touchCashier" |
         * | token | String | 获取支付收银台时返回的token | √ | 常用参数 |
         * | orderNo | String | 订单号 | √ | 常用参数 |
         * | isVouch | Bool | 是否担保 | √ | 常用参数，支付收银台为false，担保收银台为true |
         * | sign | Function | fail 回调 | √ | 常用参数 |
         * | bd_source | String | 来源 | X | 不常用参数 |
         * touch 更多参数查看支付中心的[文档](http://wiki.corp.qunar.com/pages/viewpage.action?pageId=43255424)
         *
         * **在携程客户端内使用携程支付逻辑**
         *
         * | 运行环境 | 是否支持 |
         * | :-----: | :-----: |
         * | Hy      |   √   |
         * | Hy Browser (qunar) | √    |
         * | Hy Browser (非qunar) | √    |
         * | touch   |   √  |
         * | wechat  |   √   |
         * | ctrip   |   √   |
         *
         * 参考：<a href="http://wiki.corp.qunar.com/pages/viewpage.action?pageId=43255424" target="_blank">Touch收银台获取token接口</a>，<a href="http://wiki.corp.qunar.com/pages/viewpage.action?pageId=92343298" target="_blank">hybrid收银台</a>
         */
        openCashier: {
            hy: {
                key: 'hbCashier'
            },
            wechat: {
                handle: cashierHandle
            },
            h5: {
                handle: cashierHandle
            }
        }
    };

    bind(sdk, api, config);
};


//////////////////
// WEBPACK FOOTER
// ../plugins/qunar/cashier.js
// module id = 39
// module chunks = 1 3 4